import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { UserMappingCreatePageResolver } from './user-mapping-create-page-resolver';
import { UserMappingEditPageResolver } from './user-mapping-edit-page-resolver';
import { UserMappingListPageResolver } from './user-mapping-list-page-resolver';

export function UserMappingRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={path} exact>
        <UserMappingListPageResolver />
      </Route>
      <Route path={`${path}/new`} exact>
        <UserMappingCreatePageResolver />
      </Route>
      <Route path={`${path}/:userId`}>
        <UserMappingEditPageResolver />
      </Route>
    </Switch>
  );
}
